// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterButton_wrapper__vjR_z","icon":"FilterButton_icon__iYG_X","text":"FilterButton_text__RX7cz","count":"FilterButton_count__hQE_s"};